module.exports = {"data":{"site":{"siteMetadata":{"title":"HCV Handbook","description":"Hepatitis C","manifesto":["This is a mini site dedicated to one topic only, which is Hepatitis C.","All information on this site is collected from Internet and we will credit all the sources as acknowledgement.","We build this site to provide the convenience of a one-stop knowledge base on Hepatitis C for end-user/consumer group."]}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 118
// module chunks = 60335399758886 114276838955818